export default __webpack_public_path__ + "static/media/logo.c4dab6f4.png";